import { Component } from '@angular/core';
import { HomeService } from './home.service';
import { CommonModule, DecimalPipe } from '@angular/common';
import { SecurityService } from '../../Core/Security/security.service';
import { LogService } from '../../Core/Abstract/log.service';
import { VisualsService } from '../../Core/Abstract/visuals.service';
import { Observable } from 'rxjs';
import { EventsEmitterService } from '../../Core/Abstract/emitter.service';

@Component({
    selector: 'home',
    templateUrl: 'home.component.html',
    providers: [HomeService]
})
export class HomeComponent {


    private user = {};
    private group = "home";
    private visuals: any = {};

    constructor(private homeService: HomeService,
        private securityService: SecurityService,
        private logger: LogService,
        private visualsService: VisualsService,
        private eventsEmitterService: EventsEmitterService,
        private decimalPipe: DecimalPipe) {
            
        this.securityService.navigateTo('userList');
        // this.getVisuals();
        // this.getUser();


        // this.eventsEmitterService.languageChange.subscribe(
        //     langId => {
        //         this.getVisuals();
        //     }
        // );
     
    }

    ngOnInit() {
    }

    protected getVisuals() {
        this.visuals = this.visualsService.getFromStorageAsJSON('visualsArray')[this.group];
    }

    private getUser(): void {
        this.user = localStorage.getItem('home_info') == null ? {} : this.visualsService.getFromStorageAsJSON('home_info', false);
    }

}